import { useEffect, useState } from "react";
import "../styles/contact.css";

import fbImg       from "../photos/contacts_fb.png";
import emailImg    from "../photos/contacts_email.png";
import linkedinImg from "../photos/contacts_linkedin.png";
import githubImg   from "../photos/contacts_github.png";

const CONTACTS = [
  {
    id: "facebook",
    name: "Facebook",
    img: fbImg,
    href: "https://www.facebook.com/waatteru",
    label: "Visit Profile",
  },
  {
    id: "email",
    name: "Email",
    img: emailImg,
    href: null,
    email: "justundag@gmail.com",
    label: "Copy Email",
  },
  {
    id: "linkedin",
    name: "LinkedIn",
    img: linkedinImg,
    href: "https://www.linkedin.com/in/justin-tundag-789624400",
    label: "Connect",
  },
  {
    id: "github",
    name: "GitHub",
    img: githubImg,
    href: "https://github.com/Justin-a-Bit",
    label: "View Work",
  },
];

function useReveal() {
  useEffect(() => {
    const nodes = document.querySelectorAll(".cnt-reveal");
    const obs = new IntersectionObserver(
      (entries) =>
        entries.forEach((e) => {
          if (e.isIntersecting) {
            e.target.classList.add("is-visible");
            obs.unobserve(e.target);
          }
        }),
      { root: null, threshold: 0.06 }
    );
    nodes.forEach((n) => obs.observe(n));
    return () => obs.disconnect();
  }, []);
}

function ContactCard({ contact, index }) {
  const [copied, setCopied] = useState(false);

  const handleEmailClick = () => {
    navigator.clipboard.writeText(contact.email).then(() => {
      setCopied(true);
      setTimeout(() => setCopied(false), 2000);
    });
  };

  return (
    <div
      className="cnt-card cnt-reveal"
      style={{ transitionDelay: `${index * 0.1}s` }}
    >
      <div className="cnt-card__img-wrap">
        <img
          src={contact.img}
          alt={contact.name}
          className="cnt-card__img"
          draggable={false}
        />
      </div>

      <div className="cnt-card__bottom">
        <span className="cnt-card__name">{contact.name}</span>
        {contact.id === "email" ? (
          <button className="cnt-card__btn" onClick={handleEmailClick}>
            {copied ? "Copied!" : contact.label}
          </button>
        ) : (
          <a
            href={contact.href}
            target="_blank"
            rel="noopener noreferrer"
            className="cnt-card__btn"
          >
            {contact.label}
          </a>
        )}
      </div>
    </div>
  );
}

export default function Contact() {
  useReveal();

  return (
    <div className="contact-page">
      <div className="cnt-grid">
        {CONTACTS.map((c, i) => (
          <ContactCard key={c.id} contact={c} index={i} />
        ))}
      </div>
    </div>
  );
}